"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CalendarOptionButton = _interopRequireDefault(require("./CalendarOptionButton"));

var _calendarLink = require("calendar-link");

var _calendarLinkData = require("../../../../constants/calendarLinkData");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GoogleCalendarButton = function GoogleCalendarButton(_ref) {
  var event = _ref.event,
      _ref$onAddToCalendarC = _ref.onAddToCalendarClick,
      onAddToCalendarClick = _ref$onAddToCalendarC === void 0 ? function () {} : _ref$onAddToCalendarC,
      _ref$onAddToCalendarM = _ref.onAddToCalendarMount,
      onAddToCalendarMount = _ref$onAddToCalendarM === void 0 ? function () {} : _ref$onAddToCalendarM;
  var calendarType = 'google';
  var link = (0, _calendarLink.google)(event);
  return /*#__PURE__*/_react["default"].createElement(_CalendarOptionButton["default"], {
    linkProps: {
      href: link,
      target: '_blank',
      onClick: function onClick() {
        return onAddToCalendarClick({
          calendarType: calendarType
        });
      }
    },
    onMount: function onMount() {
      return onAddToCalendarMount({
        calendarType: calendarType
      });
    },
    icon: _calendarLinkData.googleCalendarData.icon,
    calendarName: _calendarLinkData.googleCalendarData.name
  });
};

GoogleCalendarButton.propTypes = {
  event: _propTypes["default"].object.isRequired,
  onAddToCalendarClick: _propTypes["default"].func,
  onAddToCalendarMount: _propTypes["default"].func
};
var _default = GoogleCalendarButton;
exports["default"] = _default;